import BaseModal from '@c/modals/BaseModal';
import { ProductDocument } from 'models/product';
import EstimateShippingForm from './EstimateShippingForm';

type EstimateShippingResult = {
  cost: number;
  code: string;
  name: string;
  estimated: true;
};

type DesktopEstimateShippingProps = {
  product: ProductDocument;
  isOpen: boolean;
  dismiss: (result: EstimateShippingResult | null) => void;
};

export default function DesktopEstimateShipping({
  product,
  isOpen,
  dismiss,
}: DesktopEstimateShippingProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      dismiss={() => dismiss(null)}
      title="Estimate Shipping"
    >
      <div className="p-8">
        <div className="w-[40rem] p-5">
          <EstimateShippingForm
            product={product}
            onComplete={dismiss}
            onDismiss={() => dismiss(null)}
          />
        </div>
      </div>
    </BaseModal>
  );
}
